// window.$ = window.jQuery = require('jquery');
import '!script!jquery/dist/jquery.min.js';
import angular from 'angular';

import ngAnimate from 'angular-animate';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import ocLazyLoad from 'oclazyload';
import blockUI from 'angular-block-ui';
import blockUiTemplate from './blockUI.html';
import angularJWT from 'angular-jwt';
import angularToastr from 'angular-toastr';
import angularLocalStorage from 'angular-local-storage';
import Authentication from './services/authentication';
import Collection from './services/collection';
import Email from './services/email';
import Config from './config.js';

import 'ui-select/dist/select.min.css';
// import 'ui-select/dist/select.min.js';

import './lib/ui-select-0.19.8-with-free-text.js';

import 'normalize.css';
import 'animate.css';

import 'bootstrap/dist/css/bootstrap.css';
import 'angular-ui-bootstrap/dist/ui-bootstrap-tpls.js';
import 'angular-block-ui/dist/angular-block-ui.css';
import 'angular-toastr/dist/angular-toastr.css';
import 'angular-toastr/dist/angular-toastr.tpls.js';
import './app.styl';
import 'angular-i18n/angular-locale_de-de.js';

angular
    .module('contentBank', [
        uiRouter,
        ocLazyLoad,
        uiBootstrap,
        blockUI,
        angularJWT,
        angularToastr,
        angularLocalStorage,
        ngAnimate,
        'ui.select'
    ])
    .config(($locationProvider, $stateProvider, $urlRouterProvider, jwtOptionsProvider, $httpProvider, blockUIConfig) => {
        "ngInject";

        blockUIConfig.template = blockUiTemplate;
        blockUIConfig.delay = 0;

        $locationProvider.html5Mode(true).hashPrefix('!');

        $stateProvider
        // root state for users that are NOT logged in
            .state('root', {
                abstract: true,
                template: '<div ui-view="page"></div>'
            })
            // root state for users that are logged in
            .state('user', {
                abstract: true,
                template: '<user-layout class="full-height-element layout"></user-layout>',
                data: {
                    requiresLogin: true,
                },
                resolve: {
                    lazyLoad($q, $ocLazyLoad) {
                        'ngInject';

                        const deferred = $q.defer();

                        require.ensure([], function() {
                            const name = require('./components/user-layout').default.name;
                            $ocLazyLoad.load({ name }).then(function() {
                                deferred.resolve();
                            });
                        });

                        return deferred.promise;
                    }
                }
            })
            .state('user.dashboard', {
                url: '/dashboard',
                views: {
                    'page@user': {
                        template: '<dashboard></dashboard>'

                    }
                },
                data: {
                    requiresLogin: true
                },

                resolve: {
                    loadDashboard($q, $ocLazyLoad) {
                        'ngInject';

                        const deferred = $q.defer();

                        require.ensure([], function() {
                            const name = require('./components/dashboard').default.name;
                            // const productMediaListComponent = require('./components/product-media/product-media.module.js').default.name;
                            $ocLazyLoad.load({ name })
                                .then(function() {
                                    deferred.resolve();
                                    // return $ocLazyLoad.load({ productMediaListComponent });
                                });
                            // .then(function() {
                            //     deferred.resolve();
                            // });
                        });

                        return deferred.promise;
                    },
                    loadProductMediaModule($q, $ocLazyLoad) {
                        'ngInject';

                        const deferred = $q.defer();

                        require.ensure([], function() {

                            const name = require('./components/product-media/product-media.module.js').default.name;
                            $ocLazyLoad.load({ name })
                                .then(function() {
                                    deferred.resolve();
                                });
                        });

                        return deferred.promise;
                    },
                    loadProductModule($q, $ocLazyLoad) {
                        'ngInject';

                        const deferred = $q.defer();

                        require.ensure([], function() {

                            const name = require('./components/product/product.module.js').default.name;
                            $ocLazyLoad.load({ name })
                                .then(function() {
                                    deferred.resolve();
                                });
                        });

                        return deferred.promise;
                    }
                }
            })
            .state('root.login', {

                //
                // To lazy load a whole state of our app we need to add
                // a resolve method.
                url: '/login',
                views: {
                    'page@root': {
                        template: '<login-page></login-page>',
                    }
                },
                resolve: {
                    lazyLoad($q, $ocLazyLoad) {
                        'ngInject';

                        const deferred = $q.defer();

                        require.ensure([], function() {
                            const name = require('./components/login').default.name;
                            $ocLazyLoad.load({ name }).then(function() {
                                deferred.resolve();
                            });
                        });

                        return deferred.promise;
                    }
                }
            }).state('user.profile', {
                url: '/profile',
                views: {
                    'page@user': {
                        template: '<user-profile class="full-height-element"></user-profile>',
                    }
                },
                resolve: {
                    lazyLoad($q, $ocLazyLoad) {
                        'ngInject';

                        const deferred = $q.defer();

                        require.ensure([], function() {
                            const name = require('./components/userProfile').default.name;
                            $ocLazyLoad.load({ name }).then(function() {
                                deferred.resolve();
                            });
                        });

                        return deferred.promise;
                    }
                }
            })
            .state('user.productCollection', {
                url: '/product-collection',
                views: {
                    'page@user': {
                        template: '<product-collection></product-collection>',
                    }
                },
                resolve: {
                    lazyLoad($q, $ocLazyLoad) {
                        'ngInject';

                        const deferred = $q.defer();

                        require.ensure([], function() {
                            const name = require('./components/productCollection').default.name;
                            $ocLazyLoad.load({ name }).then(function() {
                                deferred.resolve();
                            });
                        });

                        return deferred.promise;
                    }
                }
            })
            .state('user.reviewCollection', {
                url: '/reviewCollection/:collectionId?overview',
                params: {
                    overview: undefined
                },
                views: {
                    'page@user': {
                        template: '<review-collection></review-collection>',
                    }
                },
                resolve: {
                    lazyLoad($q, $ocLazyLoad) {
                        'ngInject';

                        const deferred = $q.defer();

                        require.ensure([], function() {
                            const name = require('./components/reviewCollection').default.name;
                            $ocLazyLoad.load({ name }).then(function() {
                                deferred.resolve();
                            });
                        });

                        return deferred.promise;
                    }
                }
            })
            .state('reviewDraftCollection', {
                url: '/reviewCollection',
                data: {
                    requiresLogin: true
                },
                views: {
                    '@': {
                        template: '<review-draft-collection></review-draft-collection>',
                    }
                },
                resolve: {
                    lazyLoad($q, $ocLazyLoad) {
                        'ngInject';

                        const deferred = $q.defer();

                        require.ensure([], function() {
                            const name = 'contentBank.reviewDraftCollection';
                            $ocLazyLoad.load({ name }).then(function() {
                                deferred.resolve();
                            });
                        });

                        return deferred.promise;
                    }
                }
            }).state('reviewPublishedCollection', {
                url: '/reviewCollection',
                data: {
                    requiresLogin: true
                },
                views: {
                    '@': {
                        template: '<review-published-collection></review-published-collection>',
                    }
                },
                resolve: {
                    lazyLoad($q, $ocLazyLoad) {
                        'ngInject';

                        const deferred = $q.defer();

                        require.ensure([], function() {
                            const name = 'contentBank.reviewPublishedCollection';
                            $ocLazyLoad.load({ name }).then(function() {
                                deferred.resolve();
                            });
                        });

                        return deferred.promise;
                    }
                }
            })

        .state('user.myUploads', {
            url: '/my-uploads',
            data: {
                requiresLogin: true
            },
            views: {
                'page@user': {
                    template: '<my-uploads></my-uploads>',
                }
            },
            resolve: {
                lazyLoad($q, $ocLazyLoad) {
                    'ngInject';

                    const deferred = $q.defer();

                    require.ensure([], function() {
                        const name = require('./components/myUploads').default.name;
                        $ocLazyLoad.load({ name }).then(function() {
                            deferred.resolve();
                        });
                    });

                    return deferred.promise;
                }
            }
        })

        .state('admin', {
            abstract: true,
            data: {
                requiresLogin: true,
            },
            // data: {
            //     requiresLogin: true
            // },
            views: {
                '@': {
                    template: `<layout></layout>`
                },
                'sidebar@admin': {
                    template: '<sidebar></sidebar>'
                },
                'header@admin': {
                    template: '<header></header>'
                }
            },

            resolve: {
                loadSidebarComponent($q, $ocLazyLoad) {
                    'ngInject';

                    const deferred = $q.defer();

                    require.ensure([], function() {
                        const name = require('./components/admin/sidebar/sidebar.component.js').default.name;
                        $ocLazyLoad.load({ name }).then(function() {
                            deferred.resolve();
                        });
                    });

                    return deferred.promise;
                },

                loadHeaderComponent($q, $ocLazyLoad) {
                    'ngInject';

                    const deferred = $q.defer();

                    require.ensure([], function() {
                        const name = require('./components/admin/header/header.component.js').default.name;
                        $ocLazyLoad.load({ name }).then(function() {
                            deferred.resolve();
                        });
                    });

                    return deferred.promise;
                },
                loadLayoutComponent($q, $ocLazyLoad) {
                    'ngInject';

                    const deferred = $q.defer();

                    require.ensure([], function() {
                        const name = require('./components/admin/layout/layout.component.js').default.name;
                        $ocLazyLoad.load({ name }).then(function() {
                            deferred.resolve();
                        });
                    });

                    return deferred.promise;
                }
            }
        })

        .state('admin.uploader', {
            url: '/admin-uploader',
            data: {
                requiresLogin: true,
                header: 'Uploader'
            },
            views: {
                'breadcrumb@admin': {
                    template: `
                    `
                },
                'main@admin': {
                    template: `<admin-product-media-list></admin-product-media-list>`
                }
            },

            resolve: {
                loadUploaderInterface($q, $ocLazyLoad) {
                    'ngInject';

                    const deferred = $q.defer();

                    require.ensure([], function() {
                        const name = require('./components/admin/uploader/uploader.module.js').default.name;
                        // const productMediaListComponent = require('./components/product-media/product-media.module.js').default.name;
                        $ocLazyLoad.load({ name })
                            .then(function() {
                                deferred.resolve();
                                // return $ocLazyLoad.load({ productMediaListComponent });
                            });
                        // .then(function() {
                        //     deferred.resolve();
                        // });
                    });

                    return deferred.promise;
                }
            }

        })

        .state('admin.uploader.addProductToCollection', {

                url: '/add-to-collection',
                data: {
                    requiresLogin: true,
                    header: 'Add Products to Collection'
                },
                views: {
                    'breadcrumb@admin': {
                        template: `
                    `
                    },
                    'main@admin': {
                        template: `<admin-product-collection></admin-product-collection>`
                    }
                },

                resolve: {
                    loadAddProductsToCollectionComponent($q, $ocLazyLoad) {
                        'ngInject';

                        const deferred = $q.defer();

                        require.ensure([], function() {
                            const name = require('./components/admin/uploader/components/product/add-to-collection/index.js').default.name;
                            // const productMediaListComponent = require('./components/product-media/product-media.module.js').default.name;
                            $ocLazyLoad.load({ name })
                                .then(function() {
                                    deferred.resolve();
                                    // return $ocLazyLoad.load({ productMediaListComponent });
                                });
                            // .then(function() {
                            //     deferred.resolve();
                            // });
                        });

                        return deferred.promise;
                    }
                }

            })
            .state('admin.uploader.reviewCollection', {
                url: '/review-collection/:collectionId?overview',
                data: {
                    requiresLogin: true,
                    header: 'Add Products to Collection'
                },
                params: {
                    overview: undefined
                },
                views: {
                    'breadcrumb@admin': {
                        template: `
                    `
                    },
                    'main@admin': {
                        template: `<admin-review-collection></admin-review-collection>`
                    }
                },
                resolve: {
                    loadReviewCollectionComponent($q, $ocLazyLoad) {
                        'ngInject';

                        const deferred = $q.defer();

                        require.ensure([], function() {
                            const name = require('./components/admin/uploader/components/product/add-to-collection/review-collection/index.js').default.name;
                            // const productMediaListComponent = require('./components/product-media/product-media.module.js').default.name;
                            $ocLazyLoad.load({ name })
                                .then(function() {
                                    deferred.resolve();
                                });
                        });

                        return deferred.promise;
                    }
                }
            })
            .state('admin.uploader.reviewDraftCollection', {
                url: '/review-collection',
                data: {
                    requiresLogin: true,
                    header: 'Add Products to Collection'
                },
                views: {
                    'breadcrumb@admin': {
                        template: `
                    `
                    },
                    'main@admin': {
                        template: '<admin-review-draft-collection></admin-review-draft-collection>',
                    }
                }
                // resolve: {
                //     lazyLoad($q, $ocLazyLoad) {
                //         'ngInject';

                //         const deferred = $q.defer();

                //         require.ensure([], function() {
                //             const name = 'contentBank.adminReviewDraftCollection';
                //             $ocLazyLoad.load({ name }).then(function() {
                //                 deferred.resolve();
                //             });
                //         });

                //         return deferred.promise;
                //     }
                // }
            })
            .state('admin.uploader.reviewPublishedCollection', {
                url: '/review-collection',
                data: {
                    requiresLogin: true,
                    header: 'Add Products to Collection'
                },
                views: {
                    'breadcrumb@admin': {
                        template: `
                    `
                    },
                    'main@admin': {
                        template: '<admin-review-published-collection></admin-review-published-collection>',
                    }
                }
                // resolve: {
                //     lazyLoad($q, $ocLazyLoad) {
                //         'ngInject';

                //         const deferred = $q.defer();

                //         require.ensure([], function() {
                //             const name = 'contentBank.adminReviewPublishedCollection';
                //             $ocLazyLoad.load({ name }).then(function() {
                //                 deferred.resolve();
                //             });
                //         });

                //         return deferred.promise;
                //     }
                // }
            })
            .state('admin.dashboard', {
                url: '/admin-dashboard',
                data: {
                    requiresLogin: true,
                    header: 'Filters'
                },
                views: {
                    'breadcrumb@admin': {
                        template: `
                    `
                    },
                    'main@admin': {
                        template: '<admin-dashboard></admin-dashboard>'
                    }
                },
                resolve: {


                    loadDashboardComponent($q, $ocLazyLoad) {
                        'ngInject';

                        const deferred = $q.defer();

                        require.ensure([], function() {
                            const name = require('./components/admin/dashboard/dashboard.module.js').default.name;
                            $ocLazyLoad.load({ name }).then(function() {
                                deferred.resolve();
                            });
                        });

                        return deferred.promise;
                    }
                }



            })
            .state('admin.statistics', {
                url: '/admin-statistics',
                data: {
                    requiresLogin: true,
                    header: 'Statistics'
                },
                views: {
                    'breadcrumb@admin': {
                        template: `
                    `
                    },
                    'main@admin': {
                        template: '<admin-statistics></admin-statistics>'
                    }
                },
                resolve: {


                    loadDashboardComponent($q, $ocLazyLoad) {
                        'ngInject';

                        const deferred = $q.defer();

                        require.ensure([], function() {
                            const name = require('./components/admin/statistics/statistics.module.js').default.name;
                            $ocLazyLoad.load({ name }).then(function() {
                                deferred.resolve();
                            });
                        });

                        return deferred.promise;
                    }
                }



            })

        .state('admin.projects', {

            url: '/projects/:projectId',
            data: {
                requiresLogin: true,
                header: 'Projects'
            },

            views: {
                'breadcrumb@admin': {
                    template: `
                    `
                },
                'main': {
                    template: '<project-list-container></project-list-container>'
                }
            },

            resolve: {
                // lazyLoad($q, $ocLazyLoad) {
                //     'ngInject';

                //     const deferred = $q.defer();

                //     require.ensure([], function() {
                //         const name = require('./components/admin/project/components/list/project.list.module.js').default.name;
                //         $ocLazyLoad.load({ name }).then(function() {
                //             deferred.resolve();
                //         });
                //     });
                //     return deferred.promise;
                // }
                lazyLoad($q, $ocLazyLoad) {
                    'ngInject';

                    const deferred = $q.defer();

                    require.ensure([], function() {
                        const name = require('./components/admin/project/components/list.container/project.list.container.component.js').default.name;
                        $ocLazyLoad.load({ name }).then(function() {
                            deferred.resolve();
                        });
                    });
                    return deferred.promise;
                }
            }

        })


        .state('admin.productAdmin', {
            url: '/collections',
            data: {
                requiresLogin: true,
                header: 'Product admin'
            },
            ncyBreadcrumb: {
                label: `New Uploads`
            },
            views: {
                'breadcrumb@admin': {
                    template: `
                        <div ncy-breadcrumb></div>
                    `
                },
                'main@admin': {
                    template: `<product-admin></product-admin>`
                }
            },
            resolve: {

                loadDashboardComponent($q, $ocLazyLoad) {
                    'ngInject';

                    const deferred = $q.defer();

                    require.ensure([], function() {
                        const name = require('./components/productAdmin').default.name;
                        $ocLazyLoad.load({ name }).then(function() {
                            deferred.resolve();
                        });
                    });

                    return deferred.promise;
                }

            }

        })

        .state('admin.productAdmin.collection', {
            url: '/{collectionId}/products',
            data: {
                requiresLogin: true,
            },
            ncyBreadcrumb: {
                label: 'Edit Information'
            },
            views: {
                'main@admin': {
                    template: `<product-list></product-list>`
                }
            },
            resolve: {

                loadProductListComponent($q, $ocLazyLoad) {
                    'ngInject';

                    const deferred = $q.defer();

                    require.ensure([], function() {
                        const name = require('./components/productAdmin/components/product/list/product-list.module').default.name;
                        $ocLazyLoad.load({ name }).then(function() {
                            deferred.resolve();
                        });
                    });

                    return deferred.promise;
                }

            }

        })

        .state('admin.productAdmin.collection.product', {
            url: '/{productId}/edit',
            data: {
                requiresLogin: true,
            },
            ncyBreadcrumb: {
                label: '{{$resolve.product.product_information}}'
            },
            views: {
                'main@admin': {
                    // component: 'editProduct'
                    template: `<edit-product product-id="::$resolve.productId"></edit-product>`
                }
            },
            // controller: function($scope, productService, $stateParams) {
            //     $scope.product = {};

            //     productService.getProduct($stateParams.productId)
            //         .then((response) => {
            //             console.log(response);
            //             return response;
            //         })
            //         .catch((response) => {
            //             console.log(response);
            //         });

            // },
            resolve: {

                loadEditProductComponent($q, $ocLazyLoad) {
                    'ngInject';

                    const deferred = $q.defer();

                    require.ensure([], function() {
                        const name = require('./components/productAdmin/components/product/edit/product.module').default.name;
                        $ocLazyLoad.load({ name }).then(function() {
                            deferred.resolve();
                        });
                    });

                    return deferred.promise;
                },

                productId: function($stateParams) {
                    'ngInject';
                    return $stateParams.productId;
                },

                product: function($stateParams, $http) {
                    'ngInject';
                    // var deferred = this.$q.defer();

                    return $http({
                        method: 'GET',
                        url: Config.API + '/product/' + $stateParams.productId
                    }).then(function(response) {
                        // deferred.resolve(response.data);
                        return response.data;
                        ////console.log('Success ' + JSON.stringify(resp.config.data.file) + 'uploaded. Response: ' + resp.data);
                    });

                    // return deferred.promise;
                }



            }

        })



        ;

        $urlRouterProvider.otherwise('/dashboard');

        jwtOptionsProvider.config({
            tokenGetter: function() {
                return localStorage.getItem('id_token');
            },
            whiteListedDomains: [
                'localhost',
                'cbapi.q-tests.com',
                'cbapiproduction.q-tests.com',
  'cbapiproduction.centerteam.com',
                'centerteambackend.dev',
                'content-bank-local-api.com',
            ],
            unauthenticatedRedirector: ['$state', function($state) {
                $state.go('root.login');
            }]
        });
        $httpProvider.interceptors.push('jwtInterceptor');
    });

angular
    .module('contentBank')
    .service('Authentication', Authentication)
    .service('Collection', Collection)
    .service('Email', Email)
    .constant('Config', Config)
    .run(run);

// run.$inject = [
//     'authManager',
//     '$rootScope',
//     '$state'
// ];

function run(authManager, $rootScope, $state, Authentication) {
    'ngInject';
    authManager.checkAuthOnRefresh();
    authManager.redirectWhenUnauthenticated();

    $rootScope.localStorage = localStorage;
    $rootScope.$state = $state;

    $rootScope.$on('$stateChangeStart', (event, toState) => {
        if (toState.name === 'root.login' && $rootScope.isAuthenticated) {
            event.preventDefault();
            $state.go('user.dashboard');
            return;
        }

        if (toState.name === 'user.dashboard' && Authentication._getUser().is_content_bank_admin == "true") {
            event.preventDefault();
            $state.go('admin.dashboard', null, { reload: true });
            return;
        }

        if (toState.name === 'admin.dashboard' && Authentication._getUser().is_uploader == "true") {
            event.preventDefault();
            $state.go('user.dashboard', null, { reload: true });
            return;
        }

        if (Authentication._getUser().is_uploader == "false" && Authentication._getUser().is_content_bank_admin == "false") {
            event.preventDefault();
            Authentication.logOut();
            return;
        }

    });


}



// WEBPACK FOOTER //
// ./client/app/app.js